import React from 'react';
import postal from 'postal';
import { string, object, bool } from 'prop-types';

import Nav from 'react-bootstrap/Nav';
import Col from 'react-bootstrap/Col';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Dropdown from 'react-bootstrap/Dropdown';
import styles from './styles/styles.module.scss';

import { generateNavigationProps } from '../../utils/header_helper';

import MainButton from '../shared/MainButton';
import UserInfo from '../shared/UserInfo';
import Logo from '../shared/Logo';

require('./styles/dropdown.scss');
require('./styles/nav.css');
require('./styles/position.css');

class Navigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownClosing: false,
      activeDropdown: '',
      slimMode: false,
      ...generateNavigationProps(props) // props passed in for state for logging in and out without a page refresh
    };
  }

  componentDidMount() {
    if (this.props.messagingChannel) {
      this.props.messagingChannel.subscribe('navigation.slim', this.toggleSlimNavigation);
      this.props.messagingChannel.subscribe('navigation.loginUser', this.updateForLoggedInUser);
    }
  }

  componentWillUnmount() {
    // This check for "unsubscribe" prevents weird HMR issues
    if (this.props.messagingChannel && typeof this.props.messagingChannel.unsubscribe === 'function') {
      this.props.messagingChannel.unsubscribe('navigation.slim');
      this.props.messagingChannel.unsubscribe('navigation.loginUser');
    }
  }

  updateForLoggedInUser = data => {
    const loggedInState = generateNavigationProps(data);
    this.setState({ ...loggedInState });
  };

  toggleSlimNavigation = ({ slimMode }) => {
    this.setState({ slimMode });
  };

  // Use these two functions to 'debounce' dropdown closure.
  handleDropdownOpen(dropdownId) {
    this.setState({
      activeDropdown: dropdownId,
      dropdownClosing: false
    });
  }

  handleDropdownClose() {
    const { activeDropdown } = this.state;
    if (activeDropdown) {
      this.setState({ dropdownClosing: true });
    }
    setTimeout(() => {
      const { dropdownClosing } = this.state;
      if (dropdownClosing) {
        this.setState({ activeDropdown: '' });
      }
    }, 200);
  }

  renderDropdownItems(dropdowns) {
    if (!dropdowns || !dropdowns.length) {
      return null;
    }
    return dropdowns.map(item => {
      return (
        <Dropdown.Item className={styles.item} href={this.getLinkPath(item)} data-test-id={item.label} key={`dropdown-item-${item.label}`}>
          {item.label}
        </Dropdown.Item>
      );
    });
  }

  getLinkPath(linkNode) {
    return linkNode.linkPath;
  }

  renderLinkNode(linkNode, className) {
    const { activeDropdown } = this.state;
    if (linkNode.dropdown) {
      return (
        <Dropdown
          show={activeDropdown === linkNode.label || false}
          as={Nav.Item}
          className={`${styles.dropdown} ${className}`}
          id={`collasible-nav-dropdown-${linkNode.label}`}
          data-test-id={linkNode.label}
          onMouseEnter={() => this.handleDropdownOpen(linkNode.label)}
          onMouseLeave={() => this.handleDropdownClose()}
        >
          <Dropdown.Toggle
            onMouseEnter={() => this.handleDropdownOpen(linkNode.label)}
            className={`${styles.navLink} ${styles.toggle} ${activeDropdown === linkNode.label ? styles.active : ''}`}
            as={Nav.Link}
          >
            {linkNode.label} <span className={`${activeDropdown === linkNode.label ? styles.caretUp : styles.caretDown}`} />
          </Dropdown.Toggle>
          <Dropdown.Menu
            className={styles.dropdownMenu}
            onMouseEnter={() => this.handleDropdownOpen(linkNode.label)}
            onMouseLeave={() => this.handleDropdownClose()}
          >
            {this.renderDropdownItems(linkNode.dropdown)}
          </Dropdown.Menu>
        </Dropdown>
      );
    }
    return (
      <Nav.Link className={`${styles.navLink} ${className}`} href={this.getLinkPath(linkNode)} data-test-id={linkNode.label}>
        {linkNode.label}
      </Nav.Link>
    );
  }

  renderProButton() {
    if (!this.state.proButton.display) {
      return null;
    }
    return (
      <div className={styles.proButton}>
        <MainButton path={this.getLinkPath(this.state.proButton)} text={this.state.proButton.label} />
      </div>
    );
  }

  renderUserInfo() {
    const { activeDropdown } = this.state;
    return (
      <Col>
        <Nav className={`${styles.vCenter}`}>
          {this.renderLinkNode(this.state.links.help, `${styles.light} pr-4 ml-auto`)}
          {this.renderProButton()}
          <NavDropdown
            alignRight
            show={activeDropdown === 'userInfo' || false}
            data-test-id="navigation-navDropdown"
            className={`${styles.noCaret} ${styles.dropdown} ${styles.userInfo}`}
            onMouseEnter={() => this.handleDropdownOpen('userInfo')}
            onMouseLeave={() => this.handleDropdownClose()}
            title={
              <UserInfo
                name={this.state.user.name}
                reputation={`(${this.state.user.reputation.toLocaleString()})`}
                imagePath={this.state.user.imagePath}
                link={this.getLinkPath(this.state.user)}
                active={activeDropdown === 'userInfo'}
                indicator={<span className={`${activeDropdown === 'userInfo' ? styles.caretUp : styles.caretDown}`} />}
              />
            }
          >
            <div>{this.renderDropdownItems(this.state.user.dropdown)}</div>
          </NavDropdown>
        </Nav>
      </Col>
    );
  }

  renderSignupLogin() {
    return (
      <Col className={`text-right ${styles.entry}`}>
        <Nav className={`${styles.vCenter}`}>
          {this.renderLinkNode(this.state.links.help, `${styles.light} pr-4 ml-auto`)}
          <div className={styles.entry} data-test-id="navigation-signupButton">
            <MainButton
              path={this.getLinkPath(this.state.user.signup)}
              text={this.state.user.signup.label}
              data-test-id={this.state.user.signup.label}
            />
          </div>
          <div className={styles.entry} data-test-id="navigation-loginButton">
            <MainButton
              type="outline"
              path={this.getLinkPath(this.state.user.login)}
              text={this.state.user.login.label}
              data-test-id={this.state.user.login.label}
            />
          </div>
        </Nav>
      </Col>
    );
  }

  renderUserOrSignup() {
    if (this.state.slimMode) {
      return;
    }

    return this.state.user.display ? this.renderUserInfo() : this.renderSignupLogin();
  }

  render() {
    return (
      <div className="xlate-none">
        <Navbar id={styles.nav} collapseOnSelect expand="md" className={styles.nav}>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            {!this.state.slimMode && (
              <Col>
                <Nav className="mr-auto p-2">
                  {this.renderLinkNode(this.state.links.explore, 'ml-4')}
                  {this.renderLinkNode(this.state.links.plan, 'ml-4')}
                  {this.renderLinkNode(this.state.links.history, 'ml-4')}
                </Nav>
              </Col>
            )}
            <Col className={`${styles.logoContainer}`}>
              <Navbar.Brand className="mx-auto">
                <Logo
                  showProBadge={this.state.brand.proBadge.show}
                  isProBadgeActive={this.state.brand.proBadge.active}
                  proBadgeLink={this.getLinkPath(this.state.brand.proBadge)}
                  logoLink={this.getLinkPath(this.state.brand.logo)}
                />
              </Navbar.Brand>
            </Col>
            {this.renderUserOrSignup()}
          </Navbar.Collapse>
        </Navbar>
      </div>
    );
  }
}

Navigation.propTypes = {
  adminUser: bool.isRequired,
  currentUser: object,
  displayMetric: bool.isRequired,
  forceProLogo: bool,
  languageRegionCode: string,
  mobileBrowser: bool.isRequired,
  tabletBrowser: bool.isRequired,
  proUser: bool.isRequired,
  messagingChannel: object
};

Navigation.defaultProps = {
  currentUser: null,
  languageRegionCode: 'en-US',
  forceProLogo: false,
  messagingChannel: postal.channel('navigation_messagingChannel')
};

export default Navigation;
